import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import './style/Dialog.css';
import API from '../api/api';

class DeleteEventDialog extends React.Component {
    static propTypes = {
        date: PropTypes.object,
        event: PropTypes.object,
        onClose: PropTypes.func
    }
    state = {
        code: '',
        contact: null
    }
    render() {
        const submitEnabled = !isEmpty(this.state.code);
        return (
            <div className="dialog-container">
                <div className="dialog">
                    <div className="dialog-title">Dettagli prenotazione</div>
                    <div className="dialog-body">
                        <form action="" onSubmit={this.submit}>
                            <table><tbody>
                                <tr>
                                    <td>Data:</td>
                                    <td><input defaultValue={this.props.date.format("DD.MM.YYYY")} disabled type="text" /></td>
                                </tr>
                                <tr>
                                    <td>Nome:</td>
                                    <td><input defaultValue={this.props.event.firstname + " " + this.props.event.lastname} disabled type="text" /></td>
                                </tr>
                                {this.state.contact ? [(
                                    <tr key="phone">
                                        <td>Telefono:</td>
                                        <td><input defaultValue={this.state.contact.phone} disabled type="text" /></td>
                                    </tr>
                                ), null] : null}
                                <tr>
                                    <td>ID:</td>
                                    <td><input onChange={ev => this.setState({code: ev.target.value.toLowerCase()})} placeholder={"Indicato sulla tessera membro"} type="text" value={this.state.code} /></td>
                                </tr>
                                {!this.state.contact ? (
                                    <tr>
                                        <td colSpan="2">
                                            <div className="dialog-buttonbar">
                                                <button className="button-important" disabled={!submitEnabled} onClick={() => this.queryContact()} type="button">Mostra Telefono</button>
                                            </div>
                                        </td>
                                    </tr>
                                ) : null}
                                <tr>
                                    <td colSpan="2">
                                        <div className="dialog-buttonbar">
                                            <button className="button-important" disabled={!submitEnabled} type="submit">Elimina</button>
                                            <button onClick={() => this.props.onClose()} type="button">Annulla</button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody></table>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
    submit = (ev) => {
        ev.preventDefault();
        API.deleteEvent(this.props.event, this.state.code, (success, data) => {
            if (success) {
                this.props.onClose(true);
            } else {
                // eslint-disable-next-line
                alert(data);
            }
        });
    }
    queryContact = () => {
        API.queryContact(this.props.event, this.state.code, (success, data) => {
            if (success) {
                this.setState({contact: data});
            } else {
                // eslint-disable-next-line
                alert(data);
            }
        });
    }
}

export default DeleteEventDialog;
